export enum PermissionPlaceholder {
  Associated = 'ASSOCIATED',
  Collaborator = 'COLLABORATOR',
  Wildcard = '*',
}
